import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import requestDetailsSummaryTable from 'app-ui-componentlibrary/dist/go/components/common/requestDetailsSummaryTable';

export const ConnectedRequestDetailsSummaryTable = connectDynamic(
  requestDetailsSummaryTable
);

export default requestDetailsSummaryTable;
